import React from "react";
import { Snackbar } from "@mui/material";
type Props = {
  message?: React.ReactNode;
};

const NoteBox: React.FC<Props> = ({ message = "" }: Props): JSX.Element => {
  type State = {
    open: boolean;
    vertical: "top" | "bottom";
    horizontal: "center" | "left" | "right";
  };

  const [state, setState] = React.useState<State>({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal } = state;

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  return (
    <Snackbar
      className="snackbar-error flex-start"
      anchorOrigin={{ vertical, horizontal }}
      open={true}
      onClose={handleClose}
      message={message}
      key={vertical + horizontal}
    />
  );
};

export default NoteBox;
